/* -------------------------------------------------------------------------- */
/*                                 Query keys                                 */
/* -------------------------------------------------------------------------- */

export const queryKeys = {
	status: {
		key: 'status',
	},
	whoAmI: {
		key: 'who-am-i',
	},
	auth: {
		login: {
			key: '/login',
		},
		updatePassword: {
			key: '/auth/update_password',
		},
		user: {
			key: 'auth-user',
		},
	},
	app: {
		dashboard: {
			latestProjects: {
				key: 'latest-projects',
			},
			latestOffsets: {
				key: 'latest-offsets',
			},
			kpis: {
				key: 'statistics-kpis-brands',
			},
		},
		apiTokens: {
			list: {
				key: 'api-tokens-list',
			},
		},
		meterPoints: {
			list: {
				key: 'meter-points-projects',
			},
		},
		conversionFactors: {
			list: {
				key: 'conversion-factors',
			},
		},
		sites: {
			list: {
				key: 'sites',
			},
		},
		users: {
			list: {
				key: 'users',
			},
		},
		measurabilityProjects: {
			list: {
				key: 'measurability-projects',
			},
		},
		producers: {
			list: {
				key: 'producers-list',
			},
		},
		brands: {
			list: {
				key: 'brands-list',
			},
			listWithoutAdmin: {
				key: 'brands-list-without-admin',
			},
		},
		organizations: {
			list: {
				key: 'organizations-list',
			},
		},
	},
	error: {
		key: '*',
	},
} as const;
